import { Close, Open } from '../actions'
import { analytics } from './lib'
import {
  CurrencyCalculator,
  type CurrencyCalculatorProperties,
} from '../objects/CurrencyCalculator'
import { HeroExchangeRateModal } from '../objects/ImtNeobankSelectModal'

export const CurrencyCalculatorOpen = (params: CurrencyCalculatorProperties) =>
  analytics(new Open(), new CurrencyCalculator(params))

export const HeroExchangeRateModalToggle = (open: boolean) =>
  analytics(open ? new Open() : new Close(), new HeroExchangeRateModal())
